import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Toast } from 'ngx-toastr';

import { ToastType } from '@data/enum';

@Component({
    selector: '[app-generic-toast]',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './generic-toast.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    preserveWhitespaces: false,
})
export class GenericToastComponent extends Toast implements OnInit {
    private readonly _cdr = inject(ChangeDetectorRef);

    toastIcon = '';

    ngOnInit(): void {
        this.setToastIcon();
        setTimeout(() => this._cdr.detectChanges());
    }

    private setToastIcon() {
        switch (this.toastPackage?.toastType) {
            case ToastType.SUCCESS:
                this.toastIcon = 'mdi mdi-check';
                break;
            case ToastType.ERROR:
                this.toastIcon = 'mdi mdi-close';
                break;
            case ToastType.WARNING:
                this.toastIcon = 'mdi mdi-alert';
                break;
            case ToastType.INFO:
                this.toastIcon = 'mdi mdi-information-variant';
                break;
            default:
                this.toastIcon = 'mdi mdi-bell-outline';
        }
    }
}
